/**
 * The display unit a field value renders as, and the blank badge every builder starts
 * from. The per-type builders live beside their formatters; `field_badges.ts` dispatches.
 */
import type {BadgeColor, ProgressBarStyle, RatingStyle} from '@shared/field_types';

/** One rendered display unit for a field value. A multi-select yields one per selected option. */
export interface IFieldBadge {
   text: string;
   /** null renders unstyled. */
   color: BadgeColor | null;
   /** Font Awesome class string for a leading glyph; null for none. */
   icon: string | null;
   /** Set only when the number config asks for a bar; null otherwise. */
   progress: {fraction: number; showNumber: boolean; style: ProgressBarStyle} | null;
   rating: {filled: number; max: number; style: RatingStyle} | null;
}

/** A badge with no color, glyph, bar or rating. */
export function plainBadge(text: string): IFieldBadge {
   return {text, color: null, icon: null, progress: null, rating: null};
}
